import { IEntity } from "domain/Domain";
import { useRequest } from "hooks/useRequest";
import { DateTime } from "luxon";
import { IPurchasePlan } from "modules/Purchases/models/IPurchasePlans";
import { TransferencePlan } from "modules/Transferences/models/transferencePlan";

export const useOptimizationRequester = () => {
	const request = useRequest("Optimization");

	return {
		purchase: (items: any, end: DateTime) => {
			const filterItems = items ?? [];

			return request
				.POST(`purchase/${end.toFormat("yyyy-MM-dd")}`, {
					products: filterItems.filter(
						(c: any) => c.type === "product",
					),
					categories: filterItems.filter(
						(c: any) => c.type === "category",
					),
					stores: filterItems.filter((c: any) => c.type === "store"),
					tags: filterItems
						.filter((c: any) => c.type === "tag")
						.map((c: any) => c.name),
				})
				.then((c) => {
					return (
						c.data && c.data.length > 0
							? c.data.map((plan: IPurchasePlan) => ({
									...plan,
									modifier: plan.modifier ?? 0,
								}))
							: []
					) as IPurchasePlan[];
				});
		},

		distributeCount: (filterItems: any) => {
			const products = filterItems?.filter((c: any) => c.type === "product");
			const categories = filterItems?.filter((c: any) => c.type === "category");
			const stores = filterItems?.filter((c: any) => c.type === "store");
			const tags = filterItems?.filter((c: any) => c.type === "tag").map((c: any) => c.name) ?? [];

			return request.POST("distributeCount", { products, categories, stores, tags })
				.then((response: any) => response.data ?? null);
		},

		distribute: (filterItems: any, skip: number = 0, take: number = 100) => {
			const products = filterItems?.filter((c: any) => c.type === "product");
			const categories = filterItems?.filter((c: any) => c.type === "category");
			const stores = filterItems?.filter((c: any) => c.type === "store");
			const tags = filterItems?.filter((c: any) => c.type === "tag").map((c: any) => c.name) ?? [];

			return request.POST(`distribute?skip=${skip}&take=${take}`, { products, categories, stores, tags })
				.then((response: any) => response.data ?? []);
		},

		getTransferencePlansCount: (filter: IEntity[]) => {
			const products = filter?.filter((c: any) => c.type === "product");
			const categories = filter?.filter((c: any) => c.type === "category");
			const stores = filter?.filter((c: any) => c.type === "store");
			const tags = filter?.filter((c: any) => c.type === "tag").map((c: any) => c.name) ?? [];

			return request.POST("transferenceCount", { products, categories, stores, tags })
				.then((response: any) => response.data ?? null);
		},

		getTransferencePlans: (filter: IEntity[], skip: number = 0, take: number = 100) => {
			const products = filter?.filter((c: any) => c.type === "product");
			const categories = filter?.filter((c: any) => c.type === "category");
			const stores = filter?.filter((c: any) => c.type === "store");
			const tags = filter?.filter((c: any) => c.type === "tag").map((c: any) => c.name) ?? [];

			return request.POST(`transference?skip=${skip}&take=${take}`, { products, categories, stores, tags })
				.then((response: any) => response.data as TransferencePlan[]);
		},
	};
};
